{
  "ui": {
    "feedback": "Comentarios",
    "credits": "Créditos",
    "currentMaintainer": "Mantenimiento actual",
    "maintainerPeriod": "Desde 2026",
    "originalTeam": "Equipo original",
    "creditsCampaigns": "Jungla y Navidad",
    "moreSettings": "Más ajustes",
    "chooseLanguage": "Elige tu idioma",
    "notebookTools": "Herramientas del cuaderno",
    "visualGuide": "Guía con imágenes",
    "templeSoon": "Próximamente",
    "playAdventure": "Jugar",
    "story": "La historia",
    "loadingAdventure": "Preparando la aventura…",
    "storyOpening": "Una excursión escolar a la selva. Marco y Sophia exploran con sus amigos. Un pájaro de colores llama la atención de Marco y él lo sigue entre los árboles. De pronto está solo. ¡Ayuda a los exploradores a encontrar el camino!",
    "storyEnding": "Marco y Sophia llegan juntos al templo perdido. Un rostro misterioso guarda la entrada. ¡Les espera una nueva aventura!",
    "blockCategories": "Pestañas del cuaderno",
    "actions": "Acciones",
    "loops": "Bucles",
    "conditions": "Condiciones",
    "title": "Run Marco! — Una aventura en tu cuaderno",
    "home": "Inicio de Run Marco",
    "map": "Mapa de la aventura",
    "worlds": "Elige una aventura",
    "notebook": "Mi cuaderno",
    "notebookToggle": "Abrir o cerrar el cuaderno",
    "notebookOpen": "Abrir el cuaderno",
    "notebookClose": "Ver el camino",
    "page": "Página {number}",
    "level": "Ruta {number}",
    "run": "¡Vamos!",
    "stop": "Parar",
    "step": "Un paso",
    "stepTitle": "Ejecutar una instrucción",
    "reset": "Volver al inicio",
    "add": "Añadir",
    "addLabel": "Elige un bloque para añadir",
    "addHint": "Une los bloques y pulsa Jugar.",
    "undo": "Deshacer",
    "clear": "Página nueva",
    "hint": "Una pequeña pista",
    "help": "Cómo jugar",
    "settings": "Ajustes",
    "language": "Idioma del juego",
    "blockLanguage": "Idioma de los bloques",
    "blockLanguageNote": "Puedes elegir otro idioma para los bloques.",
    "musicOn": "Activar sonido",
    "musicOff": "Silenciar",
    "sound": "Música y efectos de sonido",
    "speed": "Velocidad de la aventura",
    "chooseExplorer": "Elige tu explorador",
    "explorer": "Explorador",
    "marco": "Marco",
    "sophia": "Sophia",
    "close": "Cerrar",
    "done": "¡A explorar!",
    "loading": "Buscando el camino…",
    "loadError": "No se pudo cargar la aventura. Recarga la página para intentarlo de nuevo.",
    "imageError": "No se pudieron cargar algunas imágenes. Recarga la página.",
    "gemGoal": "Encuentra la gema",
    "goal": "Encuentra la estrella dorada",
    "cover": "Ilumina cada casilla una sola vez",
    "lit": "{count} / {total} casillas iluminadas",
    "explored": "{count} / {total} rutas exploradas",
    "facing": "Mirando hacia {direction} {arrow}",
    "boardLabel": "{name} en {level}, mirando hacia {direction}. {steps}. {objective}.",
    "up": "arriba",
    "down": "abajo",
    "left": "la izquierda",
    "right": "la derecha",
    "steps_one": "{count} paso",
    "steps_other": "{count} pasos",
    "blocks_one": "{count} bloque",
    "blocks_other": "{count} bloques",
    "stars_one": "{count} estrella",
    "stars_other": "{count} estrellas",
    "place": "Añadir bloques",
    "atEnd": "Al final",
    "insideRepeat": "Dentro de repetir {number}",
    "insideIf": "Dentro de si {number}",
    "insideElse": "Dentro de si no {number}",
    "readyFirst": "Un pequeño paso. ¡Añade un bloque para avanzar y vamos!",
    "ready": "¿Adónde vamos? Prepara un plan en tu cuaderno.",
    "back": "De vuelta al inicio. Tus bloques están listos para otro intento.",
    "empty": "Primero añade un bloque a tu cuaderno.",
    "win": "¡Encontraste el camino!",
    "winCover": "¡Iluminaste el camino!",
    "winDetails": "{steps} · {blocks}",
    "brilliant": "¡Qué aventura!",
    "simpler": "¿Puedes hacerlo con menos bloques?",
    "complete": "¡Ruta completada! Tus mejores estrellas están guardadas.",
    "next": "Siguiente ruta",
    "allWorlds": "Más aventuras",
    "replay": "Jugar de nuevo",
    "shortGoal": "¡Casi! Añade unos bloques más para llegar a la estrella.",
    "shortGem": "¡Casi! Añade unos bloques más para llegar a la gema.",
    "shortCover": "Algunas casillas siguen oscuras. ¿Cómo llegamos a ellas?",
    "checking": "Observando el camino…",
    "paused": "En pausa. Jugar empieza otra vez desde el principio.",
    "going": "¡En marcha!",
    "stepped": "Un paso más cerca. Pulsa Un paso o Jugar para continuar.",
    "clueCover": "Empieza en un borde y recorre toda la figura. Un salto pasa sobre una casilla sin iluminarla.",
    "clueCondition": "Mira el camino de delante. Una condición ayuda a tu explorador a elegir qué hacer.",
    "clueRepeat": "¿Qué pasos se repiten? Pon ese patrón dentro de un bloque de repetición.",
    "clueForward": "Avanzar sigue la dirección de tu explorador. Cuenta las casillas hasta la estrella.",
    "clueGem": "Avanzar sigue la dirección de tu explorador. Cuenta las casillas hasta la gema.",
    "clueTurn": "Girar cambia la dirección sin avanzar. Sigue el camino con el dedo.",
    "mapNote": "Elige una ruta. Tus mejores estrellas se conservan.",
    "mapLevel": "Ruta {number}: {name}. {stars}.",
    "locked": "Completa la ruta anterior para desbloquear esta.",
    "soundBlocked": "Pulsa el botón del sonido para escuchar la aventura.",
    "clearTitle": "¿Pasar a una página nueva?",
    "clearNote": "Se borrarán los bloques de esta ruta. Deshacer puede recuperarlos.",
    "keep": "Conservar mis bloques",
    "clearConfirm": "Borrar bloques",
    "fresh": "Una página nueva. ¿Adónde nos llevará tu próximo plan?",
    "localProgress": "Tu progreso se guarda en este dispositivo.",
    "helpBuild": "Prepara un plan",
    "helpBuildText": "Arrastra bloques al cuaderno y únelos, o toca un bloque para añadirlo. Elige «Dentro de repetir» para añadir pasos a un bucle.",
    "helpTurn": "Sigue a tu explorador",
    "helpTurnText": "Avanzar sigue su mirada. Izquierda y derecha giran sin avanzar. Saltar recorre dos casillas.",
    "helpTry": "Prueba, observa y vuelve a probar",
    "helpTryText": "Pulsa Jugar para probar tu plan o Un paso para una instrucción. La flecha curva vuelve al inicio y conserva tus bloques.",
    "helpWorlds": "Cada aventura tiene un objetivo",
    "helpWorldsText": "En la Selva, encuentra la gema. En Navidad, ilumina cada casilla libre una vez. En el Templo y el Egeo, completa las reparaciones y los objetivos visibles y llega a la salida.",
    "noTrail": "¡Ahí no hay camino! Prueba a girar antes de avanzar.",
    "broken": "Ese puente está roto. ¿Puedes saltarlo?",
    "blocked": "Algo bloquea el paso. Prueba un salto u otra ruta.",
    "alreadyLit": "Esa casilla ya está iluminada. Visita cada casilla una sola vez.",
    "loopError": "Este plan se repite sin parar. Prueba a cambiar el bucle.",
    "repeatError": "Elige un número de repeticiones del 1 al 99.",
    "unsupported": "Quita el bloque no compatible e inténtalo de nuevo.",
    "connect": "Une los bloques en una sola cadena y pulsa Jugar.",
    "path": "camino",
    "steps_many": "{count} pasos",
    "blocks_many": "{count} bloques",
    "stars_many": "{count} estrellas",
    "backpack": "Mochila",
    "templeGems": "Gemas del templo",
    "gemsCollected": "Gemas: {count} / {total}",
    "gemsReady": "¡Has recogido todas las gemas!",
    "aegeanTitle": "Los misterios del Egeo",
    "harbour": "Puerto",
    "aegeanDescription": "Explora el puerto: repara estaciones, reutiliza rutinas y envía un número con cada encargo.",
    "templeBetaNote": "Beta · Estamos revisando los retos y las lecciones",
    "aegeanBetaNote": "Beta · Los primeros 3 niveles del puerto",
    "seasonal": "Aventura de temporada",
    "choosePreview": "Elige un nivel de muestra",
    "repairs": "Reparaciones",
    "reachExit": "Llega a la salida",
    "taskRequirements": "Objetivos de la misión",
    "lessonGuided": "Práctica guiada · completa el programa incluido",
    "lessonRepair": "Depuración · corrige el programa incluido",
    "lessonChallenge": "Desafío · crea tu propio programa",
    "acc_define_parameter": "Rutina",
    "acc_call_argument": "Usar rutina",
    "acc_repeat_parameter": "Repetir con entrada",
    "parameter": "parámetro",
    "argument": "enviar",
    "callInput": "Entrada de esta llamada",
    "inputWaiting": "Ejecuta el programa o avanza paso a paso para ver la siguiente entrada.",
    "argumentMismatch": "Una rutina con parámetro necesita una llamada con un número. Sin parámetro, usa una llamada normal.",
    "unsetParameter": "Usa el parámetro solo dentro de la rutina que lo recibe. Los parámetros están separados de la memoria compartida.",
    "memoryObjective": "Revisa el registro de reparaciones y los objetivos de salida. Se acepta cualquier programa que los cumpla.",
    "gate": "El paso está bloqueado. Revisa las reparaciones pendientes.",
    "noPickup": "Colócate sobre la herramienta antes de recogerla.",
    "creditLead": "Dirección del equipo y desarrollo de software",
    "creditArt": "Ilustración y escenarios",
    "creditAnimation": "Animación",
    "creditUX": "Diseño de interfaz y experiencia de usuario",
    "creditDesign": "Diseño del juego",
    "creditStory": "Guion",
    "creditAudio": "Música e ingeniería de sonido",
    "lightLamp": "Encender lámpara",
    "oilLamp": "Lámpara de aceite",
    "dustyStation": "estación polvorienta",
    "betaLabel": "Beta",
    "noLamp": "Sitúate sobre una lámpara apagada antes de encenderla.",
    "collected": "Herramienta recogida · lista para usar",
    "dustyPrompt": "Sitúate sobre una estación con polvo antes de usar el pincel.",
    "lampMissing": "Recoge primero la lámpara de aceite. Mira en tu mochila.",
    "recursiveRoutine": "Esta rutina se llama a sí misma. Usa otra rutina; las llamadas recursivas aún no están disponibles."
  },
  "content": {
    "jungle.title": "Expedición en la selva",
    "jungle.description": "Sigue el camino hasta el templo perdido.",
    "jungle-1": "Primeros pasos",
    "jungle-2": "Un poco más lejos",
    "jungle-3": "A la vuelta de la esquina",
    "jungle-4": "Cambia de dirección",
    "jungle-5": "Sigue el camino",
    "jungle-6": "Una nueva ruta",
    "jungle-7": "Nuevos caminos",
    "jungle-8": "Cruce en la selva",
    "jungle-9": "Encuentra tu camino",
    "jungle-10": "Piensa por adelantado",
    "jungle-11": "El camino largo",
    "jungle-12": "Una ruta sinuosa",
    "jungle-13": "Un salto valiente",
    "jungle-14": "Aparecen patrones",
    "jungle-15": "Repite el ritmo",
    "jungle-16": "Elige un camino",
    "jungle-17": "Mira antes de saltar",
    "jungle-18": "Lee el camino",
    "jungle-19": "Un desvío ingenioso",
    "jungle-20": "Bajo las copas",
    "jungle-21": "Constructor de puentes",
    "jungle-22": "Más allá del río",
    "jungle-23": "Explora las ruinas",
    "jungle-24": "Piedra y madera",
    "jungle-25": "Un salto más grande",
    "jungle-26": "Sigue las pistas",
    "jungle-27": "Más arriba",
    "jungle-28": "Sigue explorando",
    "jungle-29": "Caminos retorcidos",
    "jungle-30": "El jardín secreto",
    "jungle-31": "Patrones ocultos",
    "jungle-32": "Caminos antiguos",
    "jungle-33": "Los últimos giros",
    "jungle-34": "Hacia el templo",
    "jungle-35": "Ya casi llegamos",
    "jungle-36": "El templo perdido",
    "winter.title": "Ruta de invierno",
    "winter.description": "Deja una luz en cada huella.",
    "winter-1": "Pasos en la nieve",
    "winter-2": "Otra dirección",
    "winter-3": "Esquinas heladas",
    "winter-4": "El camino más largo",
    "winter-5": "Copo de nieve",
    "winter-6": "Bucles de invierno",
    "winter-7": "Explorador del hielo",
    "winter-8": "Giros y vueltas",
    "winter-9": "Lógica helada",
    "winter-10": "Buscador de patrones",
    "winter-11": "Maestro del camino",
    "winter-12": "Maravilla invernal",
    "temple.title": "El templo perdido",
    "temple.description": "Cuarenta salas conectadas: restaura un instrumento celeste con herramientas, memoria y tus propias rutinas."
  },
  "blockly": {
    "ARIA_LABEL_TRASH_EMPTY": "Papelera vacía",
    "OPEN_TRASH": "Abrir papelera",
    "BLOCK_LABEL_BEGIN_STACK": "Inicio de la pila",
    "WORKSPACE_LABEL_1_STACK": "1 pila de bloques",
    "WORKSPACE_LABEL_MANY_STACKS": "%1 pilas de bloques",
    "ARIA_TYPE_FIELD_NUMBER": "número",
    "ARIA_TYPE_FIELD_DROPDOWN": "lista desplegable",
    "ARIA_TYPE_FIELD_IMAGE": "imagen",
    "WORKSPACE_LABEL_PLAIN": "Mi cuaderno",
    "FIELD_LABEL_EDIT_PREFIX": "Editar %1",
    "BLOCK_LABEL_HAS_INPUT": "tiene una entrada",
    "BLOCK_LABEL_HAS_INPUTS": "tiene entradas",
    "BLOCK_LABEL_HAS_BRANCHES": "tiene %1 ramas",
    "FIELD_LABEL_OPTION_INDEX": "Opción %1",
    "INPUT_LABEL_EMPTY": "Vacío",
    "BLOCK_LABEL_DISABLED": "desactivado",
    "BLOCK_LABEL_COLLAPSED": "contraído",
    "BLOCK_LABEL_BEGIN_PREFIX": "Inicio: %1",
    "INPUT_LABEL_END_STATEMENT": "Fin: %1",
    "ARIA_TYPE_FIELD_TEXT_INPUT": "texto",
    "ARIA_TYPE_FIELD_INPUT": "entrada",
    "ARIA_TYPE_FIELD_TEXT_INPUT_ARGUMENT": "nombre de la entrada",
    "ARIA_TYPE_FIELD_TEXT_INPUT_PROCEDURE": "nombre de la rutina"
  }
}
